import {
    ClientsWorkOverviewColumn,
    ClientsWorkOverviewView,
} from "@common/types/views/clientsWorkOverviewView";
import { NamedView, ViewDensity, ViewType } from "@common/types/views/views";
import type { WorkCardFieldId } from "../board/workCardFieldColumns";
import type { GroupBy } from "../useGroupedTableData";

type WorkViewColumn = ClientsWorkOverviewView["columns"][number];

type WorkViewBoard = NonNullable<
    NonNullable<ClientsWorkOverviewView["options"]>["board"]
>;

interface BuildWorkViewParams {
    id: string;
    name: string;
    /** The columns after Service, left to right; Actions always closes the row. */
    columnIds: ClientsWorkOverviewColumn[];
    filters: ClientsWorkOverviewView["filters"];
    groupBy: GroupBy;
    /** Board display options; unset keeps the page defaults. */
    board?: Omit<WorkViewBoard, "cardFields"> & {
        /** The card's tags, in order, whatever columns List shows. */
        cardFields?: WorkCardFieldId[];
    };
}

const toColumn = (id: ClientsWorkOverviewColumn): WorkViewColumn => ({ id });

/** A built-in Work view: Service pinned left, Actions pinned right, the given columns between. */
export const buildWorkView = ({
    id,
    name,
    columnIds,
    filters,
    groupBy,
    board,
}: BuildWorkViewParams): NamedView<ClientsWorkOverviewView> => ({
    id,
    name,
    type: ViewType.CLIENTS_WORK_OVERVIEW,
    options: {
        selection: true,
        bulkActions: false,
        density: ViewDensity.MD,
        groupBy,
        ...(board && { board }),
    },
    columns: [
        { id: ClientsWorkOverviewColumn.CLIENT, options: { pin: "left" } },
        ...columnIds.map(toColumn),
        { id: ClientsWorkOverviewColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters,
});
